import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=4524c86e&scoped=true"
import script from "./transfer.vue?vue&type=script&lang=js"
export * from "./transfer.vue?vue&type=script&lang=js"
import style0 from "./transfer.vue?vue&type=style&index=0&id=4524c86e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4524c86e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4524c86e')) {
      api.createRecord('4524c86e', component.options)
    } else {
      api.reload('4524c86e', component.options)
    }
    module.hot.accept("./transfer.vue?vue&type=template&id=4524c86e&scoped=true", function () {
      api.rerender('4524c86e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/staffCustomerManage/transfer.vue"
export default component.exports